<template>
  <v-row>
    <v-col cols="12">
      <v-slide-group show-arrows>
        <v-slide-item>
          <v-avatar
            class="border--question border--dashed border--2 mr-4 cursor-pointer"
            @click="showCreateDialog"
            size="100"
          >
            <v-icon size="70" color="lighttext">add</v-icon>
          </v-avatar>
        </v-slide-item>
        <v-slide-item v-for="(item, i) in recognitions" :key="i" v-slot="{}">
          <v-badge color="transparent" overlap offset-x="50">
            <template v-slot:badge="{}">
              <v-avatar
                color="white"
                size="35"
                v-on:click="showRecognition(item)"
                class="elevation-4"
              >
                <v-img :src="$images.RECOGNITION_AVATAR"></v-img>
              </v-avatar>
            </template>
            <user-avatar
              v-on:click="showRecognition(item)"
              :user="item.user"
              size="100"
              cssClass="mr-4 text-h3 elevation-4 cursor-pointer"
              borderColor="white"
              :toolTipText="item.user.fullName"
            ></user-avatar>
          </v-badge>
        </v-slide-item>
      </v-slide-group>
    </v-col>
    <recognition-dialog ref="recognitionDialog"></recognition-dialog>
    <create-recognition-dialog
      ref="createRecognitionDialog"
      v-on:save="loadRecognitions"
    >
    </create-recognition-dialog>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import RecognitionDialog from "@/components/recognition/RecognitionDialog";
import CreateRecognitionDialog from "@/components/recognition/CreateRecognitionDialog";
export default {
  name: "RecognitionFeed",
  components: { RecognitionDialog, CreateRecognitionDialog },
  data: () => ({
    loading: false,
    filter: {}
  }),
  computed: {
    ...mapGetters({
      recognitions: "recognition/list"
    })
  },
  created() {
    this.loadRecognitions();
  },
  methods: {
    showRecognition(recognition) {
      this.$refs.recognitionDialog.showDialog(recognition);
    },
    showCreateDialog() {
      this.$refs.createRecognitionDialog.showDialog();
    },
    loadRecognitions() {
      this.loading = true;
      this.filter = {
        timeframeId: this.$enums.timeframes.LAST_6_MONTHS,
        customStartDate: null,
        customEndDate: null,
        customTimezone: moment.tz.guess(true)
      };
      Promise.all([
        this.$store.dispatch("recognition/getRecognitions", this.filter),
        this.$store.dispatch("company/getCoreValues")
      ])
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading recognitions."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-slide-group__wrapper {
  padding-top: 16px;
  padding-bottom: 16px;
}
</style>
